import { NgModule } from "@angular/core";
import {
    MedAvatarModule,
    MedBtnModule,
    MedBubbleModule,
    MedDirectiveSharedModule,
    MedGroupControlModule, MedInputModule,
    MedModalModule,
    MedMultiSelectModule, MedPaginationModule, MedRadioGroupModule, MedSearchBarModule, MedSelectModule,
} from "@mk/med-ui";
import { PaginatorModule } from "primeng/paginator";
import { ConfirmationService, SharedModule } from "primeng/api";
import { TableModule } from "primeng/table";
import { JsonPipe, NgClass, NgForOf, NgIf, NgStyle } from "@angular/common";
import {
    MedIconCloseModule,
    MedIconHistoryModule,
    MedIconPlusModule,
    MedIconRefreshModule,
    MedIconStarFillModule
} from "@mk/med-icons";
import { MultiSelectModule } from "primeng/multiselect";
import { DialogModule } from "primeng/dialog";
import { ChipsModule } from "primeng/chips";
import { AvatarModule } from "primeng/avatar";
import { RecipientsComponent } from "@app/components/recipients/recipients.component";
import { PageTitleModule } from "@app/components/page-title/page-title.module";
import { ErrorModule } from "@app/components/error/error.module";
import { LoaderModule } from "@app/components/loader/loader.module";
import { ConfirmPopupModule } from "primeng/confirmpopup";
import {OverlayPanelModule} from "primeng/overlaypanel";
import {SidebarModule} from "primeng/sidebar";

@NgModule({
  declarations: [
    RecipientsComponent,
  ],
    imports: [
        MedBtnModule,
        TableModule,
        MedBtnModule,
        PaginatorModule,
        SharedModule,
        TableModule,
        NgStyle,
        MedGroupControlModule,
        MedBubbleModule,
        NgForOf,
        NgIf,
        MedIconPlusModule,
        MedModalModule,
        MedMultiSelectModule,
        MedDirectiveSharedModule,
        NgClass,
        MedIconStarFillModule,
        MedSearchBarModule,
        MultiSelectModule,
        DialogModule,
        ChipsModule,
        AvatarModule,
        PageTitleModule,
        MedSelectModule,
        MedIconCloseModule,
        ErrorModule,
        MedPaginationModule,
        MedRadioGroupModule,
        LoaderModule,
        JsonPipe,
        MedAvatarModule,
        ConfirmPopupModule,
        OverlayPanelModule,
        MedIconHistoryModule,
        MedInputModule,
        SidebarModule,
        MedIconRefreshModule,
        // ConfirmPopupModule
    ],
  providers: [ConfirmationService],
  exports: [
    RecipientsComponent,
  ],
})
export class RecipientsModule {}
